export default {
    getUsers: (state) => state.users,
    getUser: (state) => state.users,
    getUserProjects: (state) => state.userProjects,
  }